import i18n from '@/i18n'

export default [
  {
    name: 'UseOptions',
    value: [
      { label: i18n.t('common.using'), value: 0, colorClazz: 'text-color-success' }, // 使用中
      { label: i18n.t('common.expired'), value: 1, colorClazz: 'text-color-info' } // 已过期
    ]
  },
  {
    name: 'StatusOptions',
    value: [
      { label: i18n.t('orders.using'), value: 0, colorClazz: 'text-color-success' }, // 使用中
      { label: i18n.t('common.expired'), value: 1, colorClazz: 'text-color-error' }, // 已过期
      { label: i18n.t('orders.unsubscribing'), value: 2, colorClazz: 'text-color-gold' }, // 退订中
      { label: i18n.t('packages.unsubscribed'), value: 3 } // 已退订
    ]
  }
]

